<!--
 * @Author: your name
 * @Date: 2023-01-05 10:02:11
 * @LastEditors: your name
 * @LastEditTime: 2023-02-28 17:12:12
 * @FilePath: /developer-black/src/app/routes/project/edit/properties/edit-property/agency-info/agency-info.component.html
 * @Description: 
 * 
 * Copyright (c) 2023 by 用户/公司名, All Rights Reserved. 
-->
<div style="position: relative">
  <div
    style="color: #3C50E0; font-size: 24px;   position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.85); z-index: 2; display: flex; align-items: center; justify-content: center">
    Coming soon...
  </div>
  <h4 style="">Purchase agency</h4>
  <div style="position: relative; width: fit-content; margin-top: 20px; margin-bottom: 20px">
    <input #searchInput placeholder="Search agent name" (keypress)="$event.which === 13 ? searchAgent() : 0">
    <button id="search" mat-icon-button (click)="searchAgent()">
      <mat-icon style="color: rgba(0,0,0,.3); font-size: 30px">search</mat-icon>
    </button>
  </div>
  <table mat-table [dataSource]="dataSource" style="width: 100%">
    <ng-container matColumnDef="agency">
      <th mat-header-cell *matHeaderCellDef>Agency</th>
      <td mat-cell *matCellDef="let element"> {{element.company.name}} </td>
    </ng-container>
    <ng-container matColumnDef="agent">
      <th mat-header-cell *matHeaderCellDef>Agent</th>
      <td mat-cell *matCellDef="let element"> {{element.firstName}} {{element.lastName}}</td>
    </ng-container>
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>Email</th>
      <td mat-cell *matCellDef="let element"> {{element.email}} </td>
    </ng-container>
    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef>Phone</th>
      <td mat-cell *matCellDef="let element"> {{element.phoneNumber}} </td>
    </ng-container>
    <ng-container matColumnDef="action" stickyEnd>
      <th mat-header-cell *matHeaderCellDef>Action</th>
      <td mat-cell *matCellDef="let element">
        <button mat-button style="background: #3C50E0; color: #fff" (click)="chooseAgent(element.id)">Choose</button>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-paginator [length]="total" [pageIndex]="page" [pageSize]="pageSize" (page)="getData($event)">
  </mat-paginator>
</div>